import type { HTMLElementType, ReactNode } from 'react';

import styles from './ArticleModuleHeroSidebarSection.module.scss';

type Props = {
	as?: HTMLElementType;
	children: ReactNode;
	title: string;
	className?: string;
};

export function ArticleModuleHeroSidebarSection({ as = 'section', children, title, className = '' }: Props) {
	const As = as;

	return (
		<As className={`${styles.section} ${className}`}>
			<div className={`heading3 ${styles.title}`}>{title}</div>

			{children}
		</As>
	);
}
